import { fetchWalletAssets, formatWalletAssets } from "@renec-foundation/relend-adapter"
import { atom } from "jotai"
import { metadataAtom } from "./metadata"
import { networkAtom } from "./settings"

export const rawWalletDataAtom = atom<Awaited<ReturnType<typeof fetchWalletAssets>> | null>(null)

export const walletAssetsAtom = atom((get) => {
  const rawWalletData = get(rawWalletDataAtom)
  const metadata = get(metadataAtom)
  const network = get(networkAtom)

  const data = rawWalletData && metadata ? formatWalletAssets(network, rawWalletData, metadata) : []

  return data
})

export const nativeTokenBalanceAtom = atom<number>(0)
